<template>

</template>

<script>
    export default {
        props:{
            value: Object,
            editMode: false,
            addUpdateUrl: String,
            deleteUrl: String,
            userRole: Object
        },
        name: "resources-dictionary-row",
        data() {
            return {
                key: null,
                type: null,
                content: null,
                statusMessage: null,
                isInEditMode: false,
            };
        },
        methods:{
            onSave(){
                let item = {
                    key: this.key,
                    type: this.type,
                    value: this.content
                };
                var result = this.saveToServer(item);
                if(!result) {
                    return;
                }
                result.then(() => {
                    this.isInEditMode = false;
                    this.$emit('save', item);
                });
            },
            onEdit(){
                this.$emit('edit', this.value);
            },
            onDelete(){
                this.$emit('is-busy', true);
                axios.post(this.deleteUrl, {key: this.key})
                    .then((response) => {
                        this.statusMessage = null;
                        this.$emit('is-busy', false);
                        this.showInfo('Delete is successful.');
                        this.$emit('delete', this.key);
                    })
                    .catch(() => {
                        this.showError('We cannot delete item, please try again later.');
                    })
                    .finally(()=> {
                        this.$emit('is-busy', false);
                    });
            },
            showError(message){
                let data = {
                    type: 'error',
                    text: message
                };
                this.$emit('show-message', data);
            },
            showInfo(message){
                let data = {
                    type: 'info',
                    text: message
                };
                this.$emit('show-message', data);
            },
            onCancel(){
                this.initialize();
                if(this.key) {
                    this.isInEditMode = false;
                }
                else{
                    this.$emit('cancel');
                }
            },
            initialize(){
                if(this.value) {
                    this.type = this.value.type;
                    this.content = this.value.value;
                    this.key = this.value.key;
                }
                else{
                    this.type = null;
                    this.content = null;
                    this.key = null;
                }
            },
            typeToText(type){
                switch (type) {
                    case 'text' :
                        return 'Text';
                    case 'multi-text' :
                        return 'Multi Text';
                }
            }
        },
        watch: {
            editMode(){
                this.isInEditMode = this.editMode;
            },
            value(){
                this.initialize();
            }
        },
        mounted() {
            this.initialize();
            this.isInEditMode = this.editMode;
        }
    }
</script>

<style scoped>

</style>